import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import { useUpdateInternBankDetails } from "../../adapters/Requests";
import { Bank } from "@phosphor-icons/react";

export default function BankUpdateModal({
  isOpen,
  onClose,
  intern,
  onSuccess,
  initialValues,
}) {
  const { mutate: updateBank, isLoading } = useUpdateInternBankDetails();

  const [formData, setFormData] = useState({
    bank_name: "",
    account_number: "",
    sort_code: "",
  });

  useEffect(() => {
    if (isOpen) {
      if (initialValues) {
        setFormData({
          bank_name: initialValues.bankName || "",
          account_number: initialValues.accountNumber || "",
          sort_code: initialValues.sortCode || "",
        });
      } else {
        const currentBank = intern?.InternBankAccounts?.[0] || {};
        setFormData({
          bank_name: currentBank.bank_name || "",
          account_number: currentBank.account_number || "",
          sort_code: currentBank.bank_sort_code || "",
        });
      }
    }
  }, [isOpen, intern, initialValues]);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateBank(
      { intern_id: intern.id, ...formData },
      {
        onSuccess: () => {
          onSuccess?.();
          onClose();
        },
      }
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-slate-800">
            <Bank size={20} className="text-green-600" />
            Update Bank Details
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 py-4">
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase">
              Bank Name
            </label>
            <input
              required
              className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:border-green-500 outline-none"
              value={formData.bank_name}
              onChange={(e) =>
                setFormData({ ...formData, bank_name: e.target.value })
              }
            />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase">
              Account Number
            </label>
            <input
              required
              maxLength={10}
              className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:border-green-500 outline-none"
              value={formData.account_number}
              onChange={(e) =>
                setFormData({ ...formData, account_number: e.target.value })
              }
            />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase">
              Sort Code
            </label>
            <input
              type="number"
              className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:border-green-500 outline-none"
              value={formData.sort_code}
              onChange={(e) =>
                setFormData({ ...formData, sort_code: e.target.value })
              }
            />
          </div>

          <DialogFooter className="pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50 rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-4 py-2 text-sm font-bold text-white bg-green-600 hover:bg-green-700 rounded-lg shadow-sm disabled:opacity-70"
            >
              {isLoading ? "Saving..." : "Save Changes"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
